import type { TaskKey } from '../hooks/useOnboarding';
import { trackOnboardingEvent } from '../analytics/onboardingEvents';

/**
 * Dispatch dell'evento custom 'onboarding:task-completed' che il SetupChecklist
 * ascolta per auto-completare i task. Idempotente: chiamarlo piu' volte per lo
 * stesso taskId non rompe nulla (il hook useOnboarding controlla gia' se e' gia' done).
 *
 * Punti di chiamata in v1:
 * - clientStore.createClient on first lead created -> 'lead'
 * - GoogleAuthCallback on success -> 'integrations'
 * - FattureInCloudCallback on success -> 'integrations'
 * - UserManagement.handleFormSuccess on new user created -> 'team'
 *
 * Limitation: solo client-side. Lead creati via API gateway/mobile non triggerano
 * questo evento (vedi spec sezione 5.3 known limitations).
 */
export function dispatchTaskCompleted(taskId: TaskKey, source = 'manual'): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('onboarding:task-completed', { detail: { taskId } }));
  trackOnboardingEvent('flusia.onboarding.checklist_task_completed', { task: taskId, source });
}
